import { action } from 'typesafe-actions';
import { AffiliationType, IApiList, IEmployee } from 'types';
import { IApiQueryOptions } from '../../../api/ApiClient';
import { Employees } from './types';

export const getEmployeesRequest = (affiliationType: AffiliationType, affiliationId: string, options?: IApiQueryOptions) =>
  action(Employees.GET_EMPLOYEES_REQUEST, {
    affiliationType,
    affiliationId,
    options,
  });
export const getEmployeesSuccess = (response: IApiList<IEmployee>) => action(Employees.GET_EMPLOYEES_SUCCESS, response);
export const getEmployeesError = (error: any) => action(Employees.GET_EMPLOYEES_FAIL, error);

export const getActionRequiredEmployeesCountRequest = (affiliationType: AffiliationType, affiliationId: string) => action(Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_REQUEST, { affiliationType, affiliationId });
export const getActionRequiredEmployeesCountSuccess = (response: IApiList<IEmployee>) => action(Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_SUCCESS, response);
export const getActionRequiredEmployeesCountError = (error: any) => action(Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_FAIL, error);
